import { IHomePlanBlueprint } from '@/components/organisms/or-floorplan-viewer/or-floorplan-viewer.types';
import { IGalleryImageProps } from '@/components/organisms/or-image-gallery/or-image-gallery.types';
import { SlideImage } from 'yet-another-react-lightbox';

export function mapBlueprintsToSlides(
  blueprints: IHomePlanBlueprint[],
): SlideImage[] {
  return blueprints.map((bp) => {
    const image = bp.image;

    const src =
      typeof image.src === 'string' ? image.src : (image.src?.mobile ?? '');
    const alt = typeof image.alt === 'string' ? image.alt : (image.alt ?? '');

    return {
      type: 'image',
      src,
      alt: alt as string,
      description: bp.title.toUpperCase(),
      imageFit: 'contain',
    };
  });
}

export function mapGalleryImagesToSlides(
  images: IGalleryImageProps[],
): SlideImage[] {
  return images.map((image) => {
    const { src, alt } = image;
    return {
      type: 'image',
      src,
      alt: (alt as string) ?? '',
      description: null,
      imageFit: 'contain',
      tags: image?.tags,
    };
  });
}
